/* Salon 36 — vanilla behaviours for the Dawn theme. No dependencies.
   Based on the handoff's reference/salon36.js, hardened for Shopify:
     OpeningStatus / HoursList  → [data-s36-status], [data-s36-hours]
     Carousel                   → [data-s36-carousel]
     Legal modal                → [data-s36-legal-open] / #s36-legal
   Hours come from <script type="application/json" id="s36-hours"> (snippets/salon36-hours-json.liquid). */
(function () {
  var DAY = ['SO', 'MO', 'DI', 'MI', 'DO', 'FR', 'SA'];
  var hours = [];
  try { hours = JSON.parse(document.getElementById('s36-hours').textContent); } catch (e) {}

  /* ---- the salon's clock: always Europe/Berlin, never the visitor's timezone ---- */
  function berlinNow() {
    var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
    var g = function (t) { return (p.filter(function (x) { return x.type === t; })[0] || {}).value; };
    var map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    var i = map[g('weekday')];
    return { i: i, code: DAY[i], min: (Number(g('hour')) % 24) * 60 + Number(g('minute')) };
  }
  function range(t) {
    var m = String(t || '').match(/(\d{1,2})(?::(\d{2}))?\s*[–-]\s*(\d{1,2})(?::(\d{2}))?/);
    return m ? { from: +m[1] * 60 + +(m[2] || 0), to: +m[3] * 60 + +(m[4] || 0) } : null;
  }
  function status() {
    var n = berlinNow();
    var row = hours.filter(function (r) { return r.day === n.code; })[0];
    var r = row && !row.closed ? range(row.hours) : null;
    if (r && n.min >= r.from && n.min < r.to) return { state: 'open', head: 'Jetzt geöffnet', tail: 'bis ' + Math.floor(r.to / 60) + ' Uhr' };
    if (r && n.min < r.from) return { state: 'later', head: 'Öffnet heute', tail: 'um ' + Math.floor(r.from / 60) + ' Uhr' };
    var next = hours.filter(function (x) { return !x.closed && range(x.hours); }).sort(function (a, b) {
      var d = function (x) { return (DAY.indexOf(x.day) - n.i + 7) % 7 || 7; };
      return d(a) - d(b);
    })[0];
    return { state: 'closed', head: 'Heute geschlossen', tail: next ? next.day + ' ab ' + Math.floor(range(next.hours).from / 60) + ' Uhr' : '' };
  }
  function renderStatus() {
    var s = status();
    document.querySelectorAll('[data-s36-status]').forEach(function (el) {
      el.setAttribute('data-state', s.state);
      var h = el.querySelector('[data-s36-head]'), t = el.querySelector('[data-s36-tail]'), sep = el.querySelector('[data-s36-sep]');
      if (h) h.textContent = s.head;
      if (sep) sep.textContent = s.tail ? (s.state === 'later' ? ' ' : ' · ') : '';
      if (t) { t.textContent = s.tail; t.hidden = !s.tail; }
    });
    var today = berlinNow().code;
    document.querySelectorAll('[data-s36-hours] [data-day]').forEach(function (row) {
      var on = row.getAttribute('data-day') === today;
      row.classList.toggle('is-today', on);
      var badge = row.querySelector('[data-s36-today-badge]');
      if (badge) badge.hidden = !on;
    });
  }
  renderStatus();
  setInterval(renderStatus, 60000);

  /* ---- Carousel: scroll-snap track, arrows move exactly one slide ---- */
  document.querySelectorAll('[data-s36-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-s36-track]');
    var prev = root.querySelector('[data-s36-prev]'), next = root.querySelector('[data-s36-next]');
    if (!track || !prev || !next || !track.children.length) return;
    var busy = false, timer;
    function gap() { return parseFloat(getComputedStyle(track).columnGap) || 24; }
    function sync() {
      if (busy) return;
      /* arrows only exist when there are more slides than fit */
      var overflow = track.scrollWidth > track.clientWidth + 2;
      prev.hidden = next.hidden = !overflow;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    function step(dir) {
      var slide = track.children[0].getBoundingClientRect().width + gap();
      var max = track.scrollWidth - track.clientWidth;
      var target = Math.max(0, Math.min(max, (Math.round(track.scrollLeft / slide) + dir) * slide));
      busy = true; track.style.scrollSnapType = 'none';
      track.scrollTo({ left: target, behavior: 'smooth' });
      clearTimeout(timer);
      timer = setTimeout(function () { busy = false; track.style.scrollSnapType = ''; sync(); }, 560);
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', sync, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(sync).observe(track); else window.addEventListener('resize', sync);
    sync();
  });

  /* ---- Mobile menu (burger) ---- */
  var head = document.querySelector('[data-s36-header]');
  var burger = head && head.querySelector('[data-s36-burger]');
  if (burger) {
    var setMenu = function (on) {
      head.classList.toggle('is-open', on);
      burger.setAttribute('aria-expanded', on ? 'true' : 'false');
      burger.setAttribute('aria-label', on ? 'Menü schließen' : 'Menü öffnen');
    };
    burger.addEventListener('click', function () { setMenu(!head.classList.contains('is-open')); });
    head.querySelectorAll('.s36-nav a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && head.classList.contains('is-open')) { setMenu(false); burger.focus(); } });
    document.addEventListener('click', function (e) { if (head.classList.contains('is-open') && !head.contains(e.target)) setMenu(false); });
    window.addEventListener('resize', function () { if (window.innerWidth >= 1140) setMenu(false); });
  }

  /* ---- Legal modal (Impressum / Datenschutz) ---- */
  var modal = document.getElementById('s36-legal');
  if (modal) {
    var lastFocus = null;
    var open = function (which) {
      modal.querySelectorAll('[data-s36-legal-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-s36-legal-panel') !== which; });
      modal.querySelector('[data-s36-legal-title]').textContent = which === 'impressum' ? 'Impressum' : 'Datenschutzerklärung';
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      modal.querySelector('[data-s36-legal-scroll]').scrollTop = 0;
      modal.querySelector('[data-s36-legal-close]').focus();
    };
    var close = function () {
      modal.hidden = true; document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    document.querySelectorAll('[data-s36-legal-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); open(a.getAttribute('data-s36-legal-open')); });
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    modal.querySelectorAll('[data-s36-legal-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }
})();
